<template>
    <footer
      class="flex flex-none z-20 relative items-center bg-white dark:bg-darkblue-900 justify-between lg:justify-end px-4 lg:px-10 border-t border-primary-50 dark:border-darkblue-600 pb-0 select-none"
    >
      <div class="breadcrumbs block lg:hidden">
        <!-- <base-button-icon name="hamburguer" mode="bubble" /> -->
      </div>
      <div class="content-actions flex items-center py-2 space-x-4 md:space-x-2">
        <slot name="actions"/>
      </div>
    </footer>
</template>

<script>
export default {
  name: 'base-footer',
  computed: {
    hasActions: function () {
      return this.$scopedSlots.actions
    }
  }
}
</script>

<style lang="sass" scoped>

</style>
